import { Navigate, useLocation } from 'react-router';
import { useUser } from '@clerk/clerk-react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useAuth } from '@/hooks/useAuth';
import { useTeam } from '@/hooks/useTeam';

/**
 * AuthGuard - PROTECTS ROUTES THAT REQUIRE AUTHENTICATION
 * REDIRECTS UNAUTHENTICATED USERS TO THE LOGIN PAGE WITH THE CURRENT PATH SAVED
 * SHOWS SPINNER WHILE LOADING USER DATA FROM /me API AND TEAMS
 */

const FullPageSpinner = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
);

export function AuthGuard({
  children
}) {
  const { pathname } = useLocation();
  const { isLoaded, isSignedIn } = useUser();
  const { isLoading } = useAuth();
  const { isLoading: isTeamLoading } = useTeam();

  // Show spinner while Clerk is loading
  if (!isLoaded) return <FullPageSpinner />;

  // Redirect to login if not signed in
  if (!isSignedIn) {
    return <Navigate replace to="/login" state={{ from: pathname }} />;
  }

  // Show spinner while fetching user data or teams
  if (isLoading || isTeamLoading) return <FullPageSpinner />;

  return <>{children}</>;
}